export const WizardEvents = {
  STEP_LOADING: 'STEP_LOADING',
  STEP_SAVING: 'STEP_SAVING',
  STEP_DONE_LOADING: 'STEP_DONE_LOADING',
  STEP_DONE_SAVING: 'STEP_DONE_SAVING',
  STEP_DONE_CANCELING: 'STEP_DONE_CANCELING',
  STEP_FAILED_LOADING: 'STEP_FAILED_LOADING',
  STEP_ABORTED_SAVING: 'STEP_ABORTED_SAVING',
  STEP_ABORTED_CANCELING: 'STEP_ABORTED_CANCELING',
  STEP_STOPPED: 'STEP_STOPPED',


  NAVIGATE_BACK: 'NAVIGATE_BACK',
  NAVIGATE_NEXT: 'NAVIGATE_NEXT',
  CANCEL: 'CANCEL',
  EXIT: 'EXIT',
};
